// extracted by mini-css-extract-plugin
export default {"content":"RadabankCardSettingsBlock_content__4Kb0s"};